/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Yeah_BugInputs */



/**
* | output |
* | --- |
* | "Yeah, that's a bug" |
*
* @param {Error_Heading_Yeah_BugInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_yeah_bug = /** @type {((inputs?: Error_Heading_Yeah_BugInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Yeah_BugInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, das ist ein Bug")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, c'est bien un bug")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("没错，这就是个 bug")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("對，這就是個 bug")
	if (locale === "ko") return /** @type {LocalizedString} */ ("네, 버그가 맞습니다")
	return /** @type {LocalizedString} */ ("Yeah, that's a bug")
});